module.exports = __webpack_public_path__ + "img/payment_icon_banktransfer.f9d1b34a.png";